import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function MentionsLegalesPage() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error('Error loading settings:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen pt-20 flex items-center justify-center">
        <div className="text-lg text-muted-foreground">Chargement...</div>
      </div>
    );
  }

  return (
    <div data-testid="mentions-legales-page" className="min-h-screen pt-20 pb-24 px-6 md:px-12 lg:px-24">
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="pt-12">
          <h1 className="text-5xl md:text-6xl font-serif tracking-tight leading-none mb-6">Mentions Légales</h1>
        </div>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Informations sur l'entreprise</h2>
          <div className="space-y-2 text-muted-foreground">
            <p><strong>Nom de l'agence :</strong> {settings?.legal_company_name || settings?.agency_name || "ARYA REAL ESTATE"}</p>
            <p><strong>Forme juridique :</strong> {settings?.legal_company_form || "Société Privée à Responsabilité Limitée (SPRL)"}</p>
            <p><strong>Numéro d'entreprise (BCE) :</strong> {settings?.legal_bce_number || "BE 0123.456.789"}</p>
            <p><strong>Numéro IPI (Institut Professionnel des Agents Immobiliers) :</strong> {settings?.legal_ipi_number || "123456"}</p>
            <p><strong>Siège social :</strong> {settings?.contact_address || "Avenue Louise 123, 1050 Bruxelles, Belgique"}</p>
            <p><strong>Téléphone :</strong> {settings?.contact_phone || "+32 2 123 45 67"}</p>
            <p><strong>Email :</strong> {settings?.contact_email || "contact@arya-realestate.be"}</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Agrément professionnel</h2>
          <div className="space-y-2 text-muted-foreground">
            <p>
              {settings?.legal_company_name || settings?.agency_name || "ARYA REAL ESTATE"} est agréée par l'Institut Professionnel des Agents Immobiliers (IPI) 
              conformément à la loi du 11 février 2013 organisant la profession d'agent immobilier.
            </p>
            <p><strong>Numéro d'agrément IPI :</strong> {settings?.legal_ipi_number || "123456"}</p>
            <p><strong>Assurance Responsabilité Civile Professionnelle :</strong></p>
            <p>Compagnie : {settings?.legal_insurance_company || "Assurances XYZ"}</p>
            <p>Numéro de police : {settings?.legal_insurance_policy || "RC-123456789"}</p>
            <p>Couverture territoriale : Belgique</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Réglementation applicable</h2>
          <div className="space-y-2 text-muted-foreground">
            <p>Les activités d'{settings?.legal_company_name || settings?.agency_name || "ARYA REAL ESTATE"} sont soumises aux réglementations suivantes :</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Loi du 11 février 2013 organisant la profession d'agent immobilier</li>
              <li>Code de déontologie de l'IPI</li>
              <li>Règlement Général sur la Protection des Données (RGPD)</li>
              <li>Loi du 6 avril 2010 relative aux pratiques du marché et à la protection du consommateur</li>
            </ul>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Protection des données personnelles</h2>
          <div className="space-y-2 text-muted-foreground">
            <p>
              Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, 
              de rectification, de suppression et de portabilité de vos données personnelles.
            </p>
            <p>
              Pour exercer ces droits ou pour toute question relative au traitement de vos données personnelles, 
              vous pouvez nous contacter à l'adresse : privacy@{settings?.contact_email?.split('@')[1] || 'arya-realestate.be'}
            </p>
            <p><strong>Responsable du traitement des données :</strong> {settings?.legal_company_name || settings?.agency_name || "ARYA REAL ESTATE"} {settings?.legal_company_form || "SPRL"}</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Certificat de Performance Énergétique (PEB)</h2>
          <div className="space-y-2 text-muted-foreground">
            <p>
              Conformément à la réglementation régionale en vigueur, tous nos biens sont accompagnés d'un certificat PEB 
              en cours de validité lors de leur mise en vente ou en location.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Médiation</h2>
          <div className="space-y-2 text-muted-foreground">
            <p>
              En cas de litige, vous pouvez faire appel au service de médiation pour le consommateur reconnu compétent :
            </p>
            <p><strong>Service de Médiation pour le Consommateur</strong></p>
            <p>North Gate II, Boulevard du Roi Albert II, 8 Bte 1</p>
            <p>1000 Bruxelles</p>
            <p>Email : contact@mediationconsommateur.be</p>
            <p>Tél : +32 2 702 52 00</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Hébergement du site</h2>
          <div className="space-y-2 text-muted-foreground">
            <p><strong>Hébergeur :</strong> Gandi SAS</p>
            <p><strong>Siège :</strong> 63-65 Boulevard Masséna, 75013 Paris, France</p>
            <p><strong>Site web :</strong> gandi.net</p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Propriété intellectuelle</h2>
          <div className="space-y-2 text-muted-foreground">
            <p>
              L'ensemble du contenu de ce site (textes, images, vidéos, logos) est la propriété exclusive d'{settings?.legal_company_name || settings?.agency_name || "ARYA REAL ESTATE"} 
              ou fait l'objet d'une autorisation d'utilisation. Toute reproduction, même partielle, est interdite sans autorisation préalable.
            </p>
          </div>
        </section>

        <section className="space-y-4">
          <h2 className="text-3xl font-serif tracking-tight">Cookies</h2>
          <div className="space-y-2 text-muted-foreground">
            <p>
              Ce site utilise des cookies strictement nécessaires à son fonctionnement (authentification, navigation). 
              Aucun cookie publicitaire ou de tracking n'est utilisé.
            </p>
          </div>
        </section>

        {settings?.legal_full_text && settings.legal_full_text.trim() !== '' && (
          <section className="space-y-4">
            <h2 className="text-3xl font-serif tracking-tight">Informations complémentaires</h2>
            <div className="space-y-2 text-muted-foreground whitespace-pre-wrap">
              {settings.legal_full_text}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

export default MentionsLegalesPage;